import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { AppState } from '../../config/state';
import { PatronProvider } from '../../providers/patron/patron';
import { LoadingController, ViewController, NavController, Events, NavParams, Content } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoLoginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-login',
  templateUrl: 'co-login.html'
})
export class CoLoginComponent {
  @Input() embedded: boolean = false; //if it's embedded, i assume that it's on a self check machine or something so I hide pin inputs
  libraryCardNumber: string = "";
  pin: string = "";
  searchByText = true;
  searchName: string = "";
  searchFirstName: string = "";
  searchLastName: string = "";
  searchZip: string = "";
  isForApp: boolean;
  typeToEnter: boolean = false;
  showNumberpad: boolean = false;
  pinRequired: boolean;
  @ViewChild('pinInput') pinInput;
  @ViewChild(Content) content: Content;
  @Output() onLogin: EventEmitter<any> = new EventEmitter<any>();
  cordovaAvailable: any; //lint issue solution
  private hidSubscription: any;
  sharedScreen: boolean = false;
  private scanTab: string;
  private scanTabState: string;
  private viewMode: string;
  private roamMode: string;
  private patronSearchQuery: string;
  private patronSearchResults: any;
  private patronSearchResultsTotal: number = 0;
  currentFocusedInput: string;
  barcodePlaceholder: string;
  constructor(private patronProvider: PatronProvider, private navParams: NavParams, private loading: LoadingController, private state: AppState, private viewCtrl: ViewController, private navCtrl: NavController, private events: Events, private timeout: TimeoutFunctionsProvider, private toast: ToastAlertsProvider, private hidScanner: HidScannerProvider, private sounds: SoundsProvider) {
    this.cordovaAvailable = this.state.cordovaAvailable;
    this.pinRequired = !this.state.pinless && !this.state.demo && !this.state.staff && !this.state.isRoam;
    this.searchByText = this.state.patronLookupByText;
    this.isForApp = this.state.cordovaAvailable;
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    this.events.subscribe('login:dismiss', () => this.dismiss());
    window.addEventListener('native.keyboardhide', this.scrollWindow);

    if (!this.cordovaAvailable) this.viewMode = 'selfcheck';
    if (this.state.roomBooker) this.viewMode = 'roombooker';
    if(this.state.isRoam || this.state.isRoamLite) {
      this.viewMode = 'roam';
      this.roamMode = '';
    }
    if (this.state.sharedScreen) this.sharedScreen = true;
    if (this.navParams.data.prefillScan) this.libraryCardNumber = this.navParams.get('prefillScan');
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  ionViewDidEnter(): void {
    this.state.homeScanActive = false;
    this.hidSubscription = this.hidScanner.scan.subscribe(value => {
      if (this.currentFocusedInput === 'pin') {
        this.pin = "";
        this.pin = value;
      } else {
        this.libraryCardNumber = value;
        if (this.pinRequired) {
          this.scanTabState = 'pin';
        }
        if(this.state.physicalScanner) this.roamMode = 'manual';
      }
      this.handleEnterPress();
      this.events.publish('closeKeyboard');
    });
    if(!this.state.roomBooker) this.hidScanner.start();
  }
  ngOnInit() {
    this.scanTab = 'scan';
    this.scanTabState = 'scan';
    this.state.customStrings.login && this.state.customStrings.login.barcodePlaceholder ? this.barcodePlaceholder = this.state.customStrings.login.barcodePlaceholder : this.barcodePlaceholder = "Barcode Number";
    if ((!this.pinRequired) && this.navParams.data.prefillScan){
      this.login(true);
    } else if (this.navParams.data.prefillScan) {
      this.scanTab = 'manual';
      this.handleEnterPress();
    }
  }
  ngOnDestroy() {
    this.events.unsubscribe('timeoutCalled');
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }
  ionViewWillLeave() {
    this.state.homeScanActive = true;
    this.hidSubscription.unsubscribe();
    this.hidScanner.stop();
  }
  getSearchResultsMessage() {
    let message = `Found ${this.patronSearchResultsTotal} patrons `;

    if (this.searchName.length > 0) {
      message += ` matching the name <i>${this.searchName}</i>`
    }
    if (this.searchZip.length > 0) {
      message += ` in zip code <b>${this.searchZip}</b>`
    }
    return message;
  }
  selectPatron(patron) {
    if (this.state.demo){
      this.libraryCardNumber = "28076010040820";
    } else {
      this.libraryCardNumber = patron.barcode;
    }
    this.login(true);
  }
  patronSearch() {
    this.patronSearchQuery = '';
    this.searchName = '';
    if (this.searchZip.length > 0) {
      this.patronSearchQuery += `zip: "${this.searchZip}"`;
    }
    if (this.searchFirstName.length > 0) {
      this.patronSearchQuery += `firstName: "*${this.searchFirstName}*"`;
      this.searchName = this.searchFirstName;
    }
    if (this.searchLastName.length > 0) {
      this.patronSearchQuery += `lastName: "*${this.searchLastName}*"`;
      this.searchName += (this.searchFirstName.length > 0 ? " " + this.searchLastName : this.searchLastName);
    }
    if (this.searchName.length > 0) {
      this.patronSearchQuery += `, name: "*${this.searchName}*"`;
    }
    let loader = this.loading.create({
      content: 'Searching for patron...',
    });
    loader.present();
    if (this.state.demo){
      let rawnames = [
          "Lori Smith",
          "Buck Smith",
          "Wilbur Smith",
          "Shanell Smith",
          "Refugia Smith",
          "Jacqui Smith",
          "Therese Smith",
          "Helaine Smith",
          "Jeane Smith",
          "Piper Smith",
          "Erich Smith",
          "Kellie Smith",
          "Ronald Smith",
          "Gertrudis Smith",
          "Olinda Smith",
          "Dallas Smith",
          "Donovan Smith",
          "Wes Smith",
          "Darcie Smith",
          "Michale Smith",
          "Tabitha Smith",
          "Pok Smith",
          "King Smith",
          "Miranda Smith",
          "Cameron Smith",
          "Mamie Smith",
          "Oralee Smith",
          "Angelia Smith",
          "Cristi Smith",
          "Elvera Smith",
          "Mozella Smith",
          "Shirely Smith",
          "Shyla Smith",
          "Zelda Smith",
          "Keri Smith",
          "Un Smith",
          "Jacquelynn Smith",
          "Hubert Smith",
          "Fernanda Smith",
          "Raleigh Smith",
          "Marsha Smith",
          "Beverley Smith",
          "Jesica Smith",
          "Maryetta Smith",
          "Misha Smith",
          "Cleveland Smith",
          "Emilee Smith",
          "Briana Smith",
          "Geri Smith",
          "Vivien Smith",
          "Jerri Smith",
          "Lamar Smith",
          "Malisa Smith",
          "Numbers Smith",
          "Carie Smith",
          "Enid Smith",
          "Margit Smith",
          "Dawn Smith",
          "Sofia Smith",
          "Leighann Smith",
          "Bret Smith",
          "Kenia Smith",
          "Micki Smith",
          "Kori Smith",
          "Jannet Smith",
          "Ingrid Smith",
          "Lin Smith",
          "Pearl Smith",
          "Reta Smith",
          "Waylon Smith",
          "Golden Smith",
          "Neta Smith",
          "Ada Smith",
          "Kera Smith",
          "Sharla Smith",
          "Jamika Smith",
          "Bryant Smith",
          "Kanisha Smith",
          "Carolynn Smith",
          "Ivy Smith",
          "Ariel Smith",
          "Malcolm Smith",
          "Fernanda Smith",
          "Sona Smith",
          "Ariana Smith",
          "Frida Smith",
          "Zandra Smith",
          "Shizuk Smitho"
        ]
        let names = rawnames.map(n =>{
          return {name: n, patronId: 12099414, barcode: Math.random().toFixed(14).split('.')[1].toString()};
        });
        names.sort((a,b)=> a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
        loader.dismiss().catch(err => { });
        this.roamMode = 'results';
        this.patronSearchResults = names;
        this.patronSearchResultsTotal = 88;
    } else {
      this.patronProvider.patronSearch(`{${this.patronSearchQuery}}`, 0, 100).then(results => {
        loader.dismiss().catch(err => { });
        if (!results || results.total === 0) {
          this.toast.showAlert('', 'No matching patrons found', 'warning');
          return;
        }
        this.roamMode = 'results';
        this.patronSearchResults = results.results;
        this.patronSearchResultsTotal = results.total;

      });
    }
  }
  loadMorePatrons(event) {
    this.patronProvider.patronSearch(`{${this.patronSearchQuery}}`, this.patronSearchResults.length, 100).then(results => {
      event.complete();
      this.patronSearchResults = [...this.patronSearchResults, ...results.results];
    })

  }
  scrollWindow() {
    window.scroll(0, 0);
  }
  recentLogin(event) {
    // console.log(event);
    let loader = this.loading.create({
      content: 'Getting account details...',
    });
    loader.present();

    this.navParams.data.login(event.barcode, event.pin).then((res) => {
      loader.dismiss().catch(err => { });
      if (res && res.id != null) {
        res.pin = this.pin;
        this.onLogin.emit(res);
        this.hidSubscription.unsubscribe();
        this.events.publish('closeKeyboard');
        if (!this.embedded) {
          this.dismiss(res).catch(err => { });
        }
      } else {
        this.toast.showAlert('', 'Invalid login', 'warning');
        this.onLogin.emit(null);
      }
    });
  }
  login(check) {
    this.scrollWindow();
    if (check) {
      if (this.libraryCardNumber === '') {
        this.toast.showAlert('', 'Please enter the card number', 'warning');
        return;
      }
      let loader = this.loading.create({
        content: 'Getting account details...',
      });
      loader.present();
      let pin = this.pin.toString();
      if (pin === '' && this.pinRequired) {
        this.toast.showAlert('', 'Please enter your PIN', 'warning');
        loader.dismiss().catch(err => { });
        return;
      }
      if (pin === '' || !this.pinRequired) {
        pin = undefined;
      }
      this.navParams.data.login(this.libraryCardNumber, this.pin).then((res) => {
        loader.dismiss().catch(err => { });
        if (res && res.id != null) {
          res.pin = this.pin;
          this.onLogin.emit(res);
          this.hidSubscription.unsubscribe();
          this.events.publish('closeKeyboard');
          if (!this.embedded) {
            this.dismiss(res).catch(err => { });
          }
        } else {
          this.toast.showAlert('', 'Invalid login', 'warning');
          if(this.viewMode === 'selfcheck' && this.scanTab === 'scan') this.focusInput('barcode');
          this.onLogin.emit(null);
        }
      });
    } else {
      this.onLogin.emit(false);
      if (!this.embedded) {
        try {
          this.hidSubscription.unsubscribe();
          this.events.publish('closeKeyboard');
          this.navCtrl.pop();
        } catch (ex) {
          console.log(ex);
        }
      }
    }
  }
  ngAfterContentInit() {
    setTimeout(() => {
      if (!this.navParams.data.prefillScan) this.focusInput('barcode');
    }, 1000);
  }
  numberKeyPressed(event) {
    if (event === '<') {
      this.libraryCardNumber = this.libraryCardNumber.slice(0, -1);
    } else if (event === '*') {
      // console.log(event)
    } else {
      this.libraryCardNumber += event;
    };
  }
  scrollToInput(event) {
    if (!event._elementRef || event._elementRef === undefined) {
      return;
    }
    setTimeout(() => event._elementRef.nativeElement.scrollIntoView(), 750);
  }
  onFocus(input) {
    this.currentFocusedInput = input;
  }
  onBlur() {}
  focusInput(input) {
    if (input === 'pin') {
      if (this.pinInput) {
        this.currentFocusedInput = 'pin';
        this.pinInput.setFocus(); // this is broken
      }
    }
  }
  scanForInfo() {
    let lintWindow: any = window;
    if(lintWindow.cordova && lintWindow.cordova.plugins) {
      lintWindow.cordova.plugins.CoScanner.scan({
        message: "Please scan a patron barcode",
        isISBN: false
      }, (data) => {
        if (data.success == true) {
          this.libraryCardNumber = data.result;
          if (this.pinRequired) {
            setTimeout(this.pinInput.setFocus(), 1000);
          } else {
            this.login(true);
          }
        }
      }, (error) => {
        if (error.error != 'USER_CANCELLED') {
          this.toast.showAlert('', error.message);
        }
      });
    }
  }
  handleEnterPress() {
    if (this.pinRequired) {
      if ((this.libraryCardNumber.length <= 0 && this.pin.length <= 0) || (this.libraryCardNumber.length <= 0 && this.pin.length > 0)) {
        setTimeout(() => { this.focusInput('barcode') }, 500);
      } else if (this.libraryCardNumber.length > 0 && this.pin.length <= 0) {
        setTimeout(() => { this.focusInput('pin') }, 500);
      } else if (this.libraryCardNumber.length > 0 && this.pin.length > 0) {
        this.login(true);
      }
    } else {
      this.login(true);
    }
  }

  dismiss(data?) {
    if(this.hidSubscription) this.hidSubscription.unsubscribe();
    this.scrollWindow();
    return this.viewCtrl.dismiss(data);
  }

  tryFocusInput(e) {
    if (e == 'manual') setTimeout(() => this.focusInput('barcode'), 500);
  }

  clearField(isBarcodeField) {
    this.currentFocusedInput = '';
    if (isBarcodeField) {
      this.libraryCardNumber = '';
    } else {
      this.pin = '';
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/co-login/co-login.ts